<template>
  <div class="page">
    <headers />
    <main>
      <div id="home"><homePage /></div>
      <div id="about"><about /></div>
      <div id="features"><features /></div>
      <div id="skills"><skills /></div>
      <div id="portfolio"><portfolio /></div>
      <div id="resume"><resume /></div>
      <div id="contact"><contact /></div>
      <AppFooter />
    </main>
    <ScrollToTop />
  </div>
</template>

<script setup>
import { watch } from "vue";
import { useRoute } from "vue-router";
import headers from "@/components/headers.vue";
import homePage from "@/components/homePage.vue";
import about from "@/components/about.vue";
import features from "@/components/features.vue";
import skills from "@/components/skills.vue";
import portfolio from "@/components/portfolio.vue";
import resume from "@/components/resume.vue";
import contact from "@/components/contact.vue";
import AppFooter from "@/components/layout/AppFooter.vue";
import ScrollToTop from "@/components/layout/ScrollToTop.vue";
import { useNavigation } from "@/composables/useNavigation";

const route = useRoute();
const { scrollToSection } = useNavigation();

watch(
  () => route.query.scroll,
  (sectionId) => {
    if (sectionId) {
      setTimeout(() => scrollToSection(sectionId), 80);
    }
  },
  { immediate: true }
);
</script>

<style scoped>
.page {
  min-height: 100vh;
  background: var(--color-bg);
}
</style>
